import type { ExecException } from "node:child_process";
import { exec } from "node:child_process";

export class Git {
  public async isCurrentDirUnderGitControl(): Promise<boolean> {
    try {
      const result = await this.execute("git rev-parse --is-inside-work-tree");
      return result.trim() === "true";
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  public async haveStagedChanges(): Promise<boolean> {
    try {
      const staged = await this.execute("git diff --cached | head -5");
      return staged !== "";
    } catch (err) {
      console.error(err);
      console.log("return false");
      return false;
    }
  }

  public async getGitRemoteOriginUrl(): Promise<string> {
    return this.execute("git remote get-url --push origin");
  }

  public async commit(msg: string): Promise<void> {
    console.info("committing ...");
    try {
      await this.execute(`git commit -m "${this.encodeMessage(msg)}"`);
    } catch (err) {
      console.error(err);
      process.exit(1);
    }
  }

  private encodeMessage(msg: string): string {
    return msg.replaceAll('"', '\\"').replaceAll("`", '\\`"');
  }

  private execute(cmd: string): Promise<string> {
    return new Promise((resolve, reject) => {
      exec(cmd, (err: ExecException | null, stdout: string) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(stdout);
      });
    });
  }
}
